// extracted by mini-css-extract-plugin
module.exports = {"form-row":"SingleTextConfirmDialog_form-row__20PUg","message":"SingleTextConfirmDialog_message__39177"};